import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["textMode", "voiceMode", "modeText"]
  static values = {
    welcomeUrl: String,
    needsWelcome: Boolean
  }

  connect() {
    this.isVoiceMode = false
    this.welcomeTriggered = false

    if (this.needsWelcomeValue) {
      this.observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && !this.welcomeTriggered) {
          this.welcomeTriggered = true
          this.triggerWelcome()
          this.observer.disconnect()
        }
      })
      this.observer.observe(this.element)
    }
  }

  disconnect() {
    this.observer?.disconnect()
  }

  toggleMode() {
    this.isVoiceMode = !this.isVoiceMode

    if (this.isVoiceMode) {
      this.textModeTargets.forEach(el => el.classList.add("hidden"))
      this.voiceModeTarget.classList.remove("hidden")
      this.modeTextTarget.textContent = "Text Mode"
    } else {
      this.textModeTargets.forEach(el => el.classList.remove("hidden"))
      this.voiceModeTarget.classList.add("hidden")
      this.modeTextTarget.textContent = "Voice Mode"
    }
  }

  triggerWelcome() {
    fetch(this.welcomeUrlValue, {
      method: "POST",
      headers: {
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content,
        "Accept": "text/vnd.turbo-stream.html"
      }
    })
  }
}
